(function(){
  if(customElements.get('gz-delivery-bar'))return;
  var K='gz-fdb',live,saved,booted=false,io;
  document.addEventListener('DOMContentLoaded',function(){setTimeout(function(){booted=true},0)});
  function read(){try{return JSON.parse(sessionStorage.getItem(K))}catch(e){return null}}
  function save(v){
    var first=!saved;saved=v;
    if(first)Promise.resolve().then(function(){try{sessionStorage.setItem(K,JSON.stringify(saved))}catch(e){}saved=null});
  }
  function say(t){
    if(!live){live=document.createElement('div');live.setAttribute('role','status');live.setAttribute('aria-live','polite');live.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)';document.body.appendChild(live)}
    live.textContent=t;
  }
  function watch(el){
    if(!('IntersectionObserver' in window)){return}
    el.classList.add('is-wait');
    io=io||new IntersectionObserver(function(list){
      list.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('is-wait');io.unobserve(e.target)}});
    },{threshold:.6});
    io.observe(el);
  }
  class GzDeliveryBar extends HTMLElement{
    connectedCallback(){
      var t=+this.dataset.total,m=+this.dataset.max,p=Math.min(t/m,1),done=t>=m,prev=read(),
          still=window.matchMedia('(prefers-reduced-motion: reduce)').matches,self=this,initial=!booted;
      if(still||!initial){this.classList.remove('is-enter')}
      else{watch(this)}
      if(!initial&&prev&&prev.p!==p&&!still){
        this.style.setProperty('--progress',prev.p);
        requestAnimationFrame(function(){requestAnimationFrame(function(){self.style.setProperty('--progress',p)})});
      }
      if(prev&&done&&!prev.d){
        if(!still){this.classList.add('is-celebrate');setTimeout(function(){self.classList.remove('is-celebrate')},2400)}
      }
      if(prev&&(prev.d!==done||prev.p!==p)){var l=this.querySelector('.gz-fdb__label');if(l)say(l.textContent.trim())}
      save({p:p,d:done});
    }
  }
  customElements.define('gz-delivery-bar',GzDeliveryBar);
})();
